import React, { useState, useEffect } from 'react';
import { Package2, Search, MapPin, CalendarClock, Truck, CheckCircle2, Circle, Package, IndianRupee, Clock, Phone, User, DollarSign, Box, MapPinned, Calendar } from 'lucide-react';
import NavBar from '../../../../component/b2c/navBar/navBar';
import Sidebar from '../../../../component/b2c/sidebar/sidebar';
import { useMyContext } from '../../../../context/MyContext';
import { AlertCircle, ClipboardList, PackageSearch } from 'lucide-react';
import '../../../../css/custom-scrollbar.css';
import axios from 'axios';
import toast from 'react-hot-toast';
import { Base_Url, track } from '../../../../config/config';
import FullPageLoader from '../../../../component/fullPageLoader/fullPageLoader';


const OrderTracking = () => {
  const [isPageLoading, setIsPageLoading] = useState(false)
  const [waybillNumber, setWaybillNumber] = useState('');
  const [orderTrackingInfo, setOrderTrackingInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const { isDarkMode, isToggleSidebar, orderid, setorderId } = useMyContext();

  useEffect(() => {
    if (orderid) {
      handleTrack();
    }
  }, [orderid]);


  const handleTrack = async () => {
    const trackingNumber = (waybillNumber || orderid)?.toString().trim();

    if (!trackingNumber) {
      setError('Please enter a valid order ID');
      setOrderTrackingInfo(null);
      return;
    }

    setIsLoading(true);
    setIsPageLoading(true);
    setError('');

    const token = localStorage.getItem('token');
    const cus_id = localStorage.getItem('cus_id');

    try {
      const requestPayload = {
        order_id: trackingNumber,
        shipment_type: 'Forward'
      };
      const response = await axios.post(Base_Url + track, requestPayload, {
        headers: {
          'token': token,
          'cus_id': cus_id,
          'Content-Type': 'application/json'
        }
      });
      if (response.data.status === "SUCCESS") {
        setOrderTrackingInfo(response.data.data.ShipmentData[0].Shipment);
        setError('');
        setIsPageLoading(false);
        if (orderid && !waybillNumber) {
          setorderId(null);
        }
      }
      else {
        setError(response.data.message);
        setIsPageLoading(false);
      }
    } catch (err) {
      console.error('Tracking error:', err.response?.data || err.message);
      setError('Failed to fetch tracking information. Please try again.');
      setOrderTrackingInfo(null);
      setIsPageLoading(false);
    } finally {
      setIsLoading(false);
      setIsPageLoading(false);
    }
  };

      const glass =
        "backdrop-blur-2xl backdrop-saturate-150 bg-white/50 dark:bg-white/[0.06] " +
        "border border-white/60 dark:border-white/10 " +
        "shadow-[0_8px_32px_rgba(31,41,55,0.08)]";

  const formatDate = (dateString) => {
    if (!dateString) return "Not Available";
    return new Date(dateString).toLocaleString();
  };

  const DetailRow = ({ label, value, icon: Icon }) => (
    <div className={`flex items-center justify-between py-1.5 border-b last:border-b-0 ${isDarkMode ? 'border-white/10' : 'border-black/10'}`}>
      <div className="flex items-center gap-1.5">
        {Icon && (
          <div className={`w-5 h-5 rounded-lg flex items-center justify-center flex-shrink-0 ${isDarkMode ? 'bg-white/5' : 'bg-black/5'}`}>
            <Icon className={`w-3 h-3 ${isDarkMode ? 'text-white/40' : 'text-black/40'}`} />
          </div>
        )}
        <span className={`text-[9px] font-medium ${isDarkMode ? 'text-white/50' : 'text-black/50'}`}>{label}</span>
      </div>
      <span className={`text-[10px] font-medium text-right ${isDarkMode ? 'text-white' : 'text-black'}`}>{value || "Not Available"}</span>
    </div>
  );

  const getStepIcon = (scan, isLatest) => {
    const status = scan.ScanDetail.Scan.toLowerCase() || scan?.ScanDetail?.ScanType;
    if (status) {
      return (
        <div className={`w-6 h-6 rounded-full flex items-center justify-center ring-2 ${isDarkMode ? 'ring-white/10 bg-white/10' : 'ring-black/10 bg-black/10'}`}>
          <CheckCircle2 className={`w-3 h-3 ${isDarkMode ? 'text-white' : 'text-black'}`} />
        </div>
      );
    }
    if (isLatest) {
      return (
        <div className={`relative inline-flex items-center justify-center w-6 h-6 rounded-full border animate-pulse ${isDarkMode ? 'border-white/30 bg-white/10' : 'border-black/30 bg-black/10'}`}>
          <Truck className={`w-3 h-3 ${isDarkMode ? 'text-white' : 'text-black'}`} />
        </div>
      );
    }
    return (
      <div className={`w-6 h-6 rounded-full flex items-center justify-center ${isDarkMode ? 'bg-white/5' : 'bg-black/5'}`}>
        <Circle className={`w-2.5 h-2.5 ${isDarkMode ? 'text-white/20' : 'text-black/20'}`} />
      </div>
    );
  };

  // Reusable section card wrapper
  const InfoCard = ({ icon: Icon, title, children }) => (
    <div className={`border rounded-lg transition-shadow overflow-hidden ${isDarkMode ? "bg-black border-white/10" : "bg-white border-black/10"}`}>
      <div className={`flex items-center gap-2 px-3 pt-2.5 pb-2 border-b ${isDarkMode ? 'border-white/10' : 'border-black/10'}`}>
        <div className={`w-6 h-6 rounded-lg flex items-center justify-center flex-shrink-0 ${isDarkMode ? 'bg-white/10' : 'bg-black/10'}`}>
          <Icon className={`w-3 h-3 ${isDarkMode ? 'text-white' : 'text-black'}`} />
        </div>
        <h2 className={`text-[10px] font-bold ${isDarkMode ? 'text-white' : 'text-black'}`}>{title}</h2>
      </div>
      <div className="px-3 py-2">
        {children}
      </div>
    </div>
  );

  const DeliveryInfoPanel = () => (
    <div className="space-y-2.5">
      {/* Shipment Overview Card */}
      <InfoCard icon={Package2} color="white" title="Shipment Overview">
        <DetailRow label="AWB Number" value={orderTrackingInfo?.AWB} icon={Package} />
        <DetailRow label="Order ID" value={orderTrackingInfo?.ReferenceNo} icon={Package2} />
        <DetailRow label="Order Type" value={orderTrackingInfo?.OrderType} icon={Box} />
        <DetailRow label="Invoice Amount" value={`₹${orderTrackingInfo?.InvoiceAmount || 0}`} icon={IndianRupee} />
        <DetailRow label="COD Amount" value={`₹${orderTrackingInfo?.CODAmount || 0}`} icon={IndianRupee} />
        <DetailRow label="Quantity" value={orderTrackingInfo?.Quantity} icon={Box} />
      </InfoCard>

      {/* Location Details */}
      <InfoCard icon={MapPinned} title="Location Details">
        <DetailRow label="Origin" value={orderTrackingInfo?.Origin} icon={MapPin} />
        <DetailRow label="Destination" value={orderTrackingInfo?.Destination || "Not specified"} icon={MapPin} />
        <DetailRow label="Pickup Location" value={orderTrackingInfo?.PickupLocation} icon={MapPin} />
      </InfoCard>

      {/* Consignee Details */}
      <InfoCard icon={User} title="Consignee Details">
        {orderTrackingInfo?.Consignee && (
          <>
            <DetailRow label="Name" value={orderTrackingInfo.Consignee.Name} icon={User} />
            <DetailRow label="City" value={orderTrackingInfo.Consignee.City || orderTrackingInfo.Consignee.State} icon={MapPin} />
            <DetailRow label="Pin Code" value={orderTrackingInfo.Consignee.PinCode} icon={MapPin} />
            <DetailRow label="Country" value={orderTrackingInfo.Consignee.Country} icon={MapPin} />
          </>
        )}
      </InfoCard>

      {/* Dates Information */}
      <InfoCard icon={Calendar} title="Important Dates">
        <DetailRow label="Pickup Date" value={formatDate(orderTrackingInfo?.PickUpDate)} icon={Calendar} />
        <DetailRow label="Expected Delivery" value={formatDate(orderTrackingInfo?.ExpectedDeliveryDate)} icon={Calendar} />
        <DetailRow label="First Attempt Date" value={formatDate(orderTrackingInfo?.FirstAttemptDate)} icon={Calendar} />
      </InfoCard>

      {/* Status Banner */}
      <div className={`p-3 rounded-lg border ${isDarkMode ? 'border-white/10 bg-white/5' : 'border-black/10 bg-black/5'}`}>
        <div className="flex items-center gap-1.5 mb-1.5">
          <div className={`w-5 h-5 rounded-lg flex items-center justify-center ${isDarkMode ? 'bg-white/10' : 'bg-black/10'}`}>
            <Clock className={`w-3 h-3 ${isDarkMode ? 'text-white' : 'text-black'}`} />
          </div>
          <h3 className={`text-[9px] font-bold ${isDarkMode ? 'text-white' : 'text-black'}`}>Current Status</h3>
        </div>
        <div className="space-y-0.5">
          <p className={`text-[11px] font-bold ${isDarkMode ? 'text-white' : 'text-black'}`}>
            {orderTrackingInfo?.Status?.Status}
          </p>
          <p className={`text-[9px] leading-relaxed ${isDarkMode ? 'text-white/50' : 'text-black/50'}`}>
            {orderTrackingInfo?.Status?.Instructions}
          </p>
          <p className={`text-[8px] pt-0.5 ${isDarkMode ? 'text-white/30' : 'text-black/30'}`}>
            Last Updated: {formatDate(orderTrackingInfo?.Status?.StatusDateTime)}
          </p>
        </div>
      </div>
    </div>
  );

  return (
    <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'bg-black' : 'bg-white'}`}>
    <div className="pointer-events-none absolute -top-32 -left-24 h-96 w-96 rounded-full bg-indigo-200/30 dark:bg-indigo-500/10 blur-3xl" />

        <NavBar />
                <div className="flex flex-1 overflow-hidden">
                    {isToggleSidebar && (
                        <div className={`w-64 m-3 rounded-3xl ${glass} overflow-hidden`}>
                            <Sidebar />
                        </div>
                    )}

        <FullPageLoader
          isLoading={isPageLoading}
          message="Processing your request..."
        />

        <div className={`flex-1 p-3 md:p-4 overflow-auto custom-scrollbar ${isDarkMode ? 'bg-black' : 'bg-gray-100'}`}>
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-3 max-w-7xl mx-auto">
            {/* Main Tracking Section */}
            <div className={`lg:col-span-2 border rounded-lg overflow-hidden h-fit ${isDarkMode ? "bg-black border-white/10" : "bg-white border-black/10"}`}>
              {/* Header */}
              <div className={`px-4 py-3 border-b ${isDarkMode ? 'border-white/10' : 'border-black/10'}`}>
                <div className="flex items-center gap-2">
                  <div className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 ${isDarkMode ? 'bg-white/10' : 'bg-blue-600'}`}>
                    <Package2 color='white' className={`w-4 h-4 ${isDarkMode ? 'text-white' : 'text-black'}`} />
                  </div>
                  <div>
                    <p className={`text-[8px] uppercase tracking-widest font-semibold ${isDarkMode ? 'text-white/40' : 'text-black/40'}`}>Live Tracking</p>
                    <h1 className={`text-sm font-bold ${isDarkMode ? 'text-white' : 'text-black'}`}>Track Your Shipment</h1>
                  </div>
                </div>
              </div>

              <div className="p-4">
                <div className="space-y-3">
                  {/* Search section */}
                  <div className="flex gap-1.5">
                    <div className="relative flex-1">
                      <Search color='blue' className={`absolute left-2.5 top-1/2 -translate-y-1/2 w-3.5 h-3.5 ${isDarkMode ? 'text-white/30' : 'text-black/30'}`} />
                      <input
                        type="text"
                        placeholder="Enter Order ID"
                        onChange={(e) => setWaybillNumber(e.target.value)}
                        className={`w-full pl-8 pr-3 py-1.5 rounded-lg border outline-none transition-all text-[10px] ${isDarkMode
                            ? "bg-black border-white/10 text-white placeholder-white/30 focus:border-white/40 focus:ring-1 focus:ring-white/20"
                            : "bg-white border-black/10 text-black placeholder-black/30 focus:border-black/40 focus:ring-1 focus:ring-black/20"
                          }`}
                      />
                    </div>
                    <button
                      onClick={handleTrack}
                      disabled={isLoading}
                      className={`px-3 py-1.5 rounded-lg transition-all duration-200 text-[10px] font-semibold flex items-center gap-1.5 disabled:opacity-50 ${isDarkMode ? 'bg-white text-black hover:bg-white/90' : 'bg-blue-600 text-white hover:bg-black/90'}`}
                    >
                      {isLoading ? (
                        <div className={`w-3 h-3 border-2 ${isDarkMode ? 'border-black' : 'border-white'} border-t-transparent rounded-full animate-spin`} />
                      ) : (
                        <>
                          <Search className="w-3.5 h-3.5" />
                          <span>Track</span>
                        </>
                      )}
                    </button>
                  </div>

                  {error && (
                    <div className={`flex items-start gap-2 p-2.5 rounded-lg border ${isDarkMode ? 'border-white/20 bg-white/5' : 'border-black/20 bg-black/5'}`}>
                      <AlertCircle className={`w-3.5 h-3.5 flex-shrink-0 mt-0.5 ${isDarkMode ? 'text-white/60' : 'text-black/60'}`} />
                      <p className={`text-[10px] ${isDarkMode ? 'text-white/60' : 'text-black/60'}`}>{error}</p>
                    </div>
                  )}

                  {!orderTrackingInfo && !error && (
                    <div className="flex flex-col items-center justify-center py-10 text-center">
                      <div className={`w-10 h-10 rounded-lg flex items-center justify-center mb-2 ${isDarkMode ? 'bg-white/5' : 'bg-blue-600'}`}>
                        <PackageSearch color='white' className={`w-5 h-5 ${isDarkMode ? 'text-white/30' : 'text-black/30'}`} />
                      </div>
                      <p className={`text-[14px] font-medium ${isDarkMode ? 'text-white/40' : 'text-black/40'}`}>Enter an Order ID to see live tracking</p>
                    </div>
                  )}

                  {orderTrackingInfo && (
                    <div className="space-y-0.5 mt-4">
                      {orderTrackingInfo.Scans?.map((scan, index) => (
                        <div key={index} className="relative pb-4 last:pb-0">
                          <div className="flex items-start gap-2.5">
                            <div className="flex-shrink-0 relative z-10 mt-0.5">
                              {getStepIcon(scan, index === 0)}
                            </div>
                            <div className={`flex-1 space-y-0.5 rounded-lg px-2.5 py-1.5 ${index === 0 ? (isDarkMode ? 'bg-white/5' : 'bg-black/5') : ''}`}>
                              <p className={`text-[10px] font-semibold ${isDarkMode ? 'text-white' : 'text-black'}`}>
                                {scan.ScanDetail.Instructions}
                              </p>
                              <p className={`text-[8px] font-medium ${isDarkMode ? 'text-white/30' : 'text-black/30'}`}>
                                {formatDate(scan.ScanDetail.StatusDateTime)}
                              </p>
                              <p className={`text-[8px] ${isDarkMode ? 'text-white/40' : 'text-black/40'}`}>
                                {scan.ScanDetail.ScannedLocation}
                              </p>
                            </div>
                          </div>
                          {index < orderTrackingInfo.Scans.length - 1 && (
                            <div className={`absolute left-2.5 top-6 w-px h-full ${isDarkMode ? 'bg-white/10' : 'bg-black/10'}`} />
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* Info Panel */}
            <div className="lg:col-span-3">
              <DeliveryInfoPanel />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};


export default OrderTracking;